// 针对适配器 应该只对数据进行处理 不修改原始值

// todolist  建议将数据端的接口统一成一个
// 从客户端获取首屏数据
function createDataFromClient() {
    return new Promise((resolve, reject) => {
        // let { code, treeid, industry } = this.detail;
        this.$client
            // .getList(code, treeid, industry)
            //this.detail 是从外部组件中传递至本组件的 所有 location.search中的参数
            .getList(this.detail)
            .then((res) => {
                resolve(res);
            })
            .catch((err) => {
                console.warn(err);
            });
    });
}
// 从服务端获取首屏数据
function createDataFromServer() {
    return new Promise((resolve, reject) => {
        let { code, tagname } = this.pageDetail;
        return this.$http
            .getListData(code, tagname, "")
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                console.warn(err);
            });
    });
}

export default {
    view_point: {
        createData() {
            return createDataFromClient.call(this);
        },
        followData() {
            return false;
        },
        formatList() {
            this.tabList = "";
        },
    },
    notice: {
        createData() {
            return createDataFromClient.call(this);
        },
        followData() {
            let code = this.pageDetail.code;
            const lastItem = this.tabList[this.tabList.length - 1]
            let ts = lastItem.time || lastItem.ctime;
            return this.$http.getNoticeListData(code, ts);
        },
        formatList() {
            this.tabList = "";
        },
    },
    tags: {
        createData() {
            // let { code, tagname } = this.pageDetail;
            return createDataFromServer.call(this);
        },
        followData() {
            let { code, tagname } = this.pageDetail;
            let seq =
                this.tabList[this.tabList.length - 1].id ||
                this.tabList[this.tabList.length - 1].seq;
            return this.$http.getListData(code, tagname, seq);
        },
        formatList() {
            this.tabList = "";
        },
    },
    report: {
        createData() {
            return createDataFromClient.call(this);
        },
        followData() {
            let code = this.pageDetail.code;
            const lastItem = this.tabList[this.tabList.length - 1]
            let ts = lastItem.time || lastItem.ctime;
            return this.$http.getReportListData(code, ts);
        },
        formatList() {
            this.tabList = "";
        },
    },
    news: {
        createData() {
            return createDataFromClient.call(this);
        },
        followData() {
            let code = this.pageDetail.code;
            let seq =
                this.tabList[this.tabList.length - 1].id ||
                this.tabList[this.tabList.length - 1].seq;
            return this.$http.getListData(code, "", seq);
        },
        formatList() {
            this.tabList = "";
        },
    },
    broker: {
        createData() {
            return createDataFromClient.call(this);
        },
        followData() {
            let code = this.pageDetail.code;
            let seq =
                this.tabList[this.tabList.length - 1].id ||
                this.tabList[this.tabList.length - 1].seq;
            return this.$http.getListData(code, "", seq);
        },
        formatList() {
            this.tabList = "";
        },
    },
    industry_report: {
        createData() {
            return createDataFromClient.call(this);
        },
        followData() { },
        formatList() {
            this.tabList = "";
        },
    },
    industry: {
        createData() {
            return createDataFromClient.call(this);
        },
        followData() { },
        formatList() {
            this.tabList = "";
        },
    },
};